import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import LatestNews from './components/LatestNews';
import HotRanking from './components/HotRanking';
import SiteIntro from './components/SiteIntro';
import { getHotNews } from '@/utils/newsUtils';
import { useSeo } from '@/hooks/useSeo';

export default function Home() {
  useSeo({
    title: '吃瓜网-最新热点新闻与娱乐八卦平台',
    description:
      '吃瓜网提供丰富的热点新闻、娱乐八卦和社会事件资讯，涵盖明星动态、网络热议话题，帮助用户第一时间了解最新娱乐信息。',
    keywords: '吃瓜网,热点新闻,娱乐八卦,明星动态,社会事件,网络热议,新闻资讯',
    canonicalPath: '/',
  });

  const hot = getHotNews(5);
  const hotKeywords = ['古装剧定档', '城市漫步', '社区食堂', '电子榨菜', '音乐节', '胶片相机'];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1 w-full">
        <section className="w-full bg-gradient-to-br from-primary-50 via-background-50 to-background-100 border-b border-background-200">
          <div className="w-full px-4 md:px-8 py-8 md:py-10">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
              <div>
                <h1 className="text-3xl md:text-5xl font-extrabold font-heading tracking-tight text-foreground-950">
                  吃瓜网
                </h1>
                <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl leading-relaxed">
                  最新热点新闻与娱乐八卦平台，追踪明星动态、网络热议与社会事件，第一时间看懂热点。
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2 max-w-xl">
                <span className="text-xs text-foreground-400 whitespace-nowrap">热搜关键词</span>
                {hotKeywords.map((k) => (
                  <Link
                    key={k}
                    to={`/search?q=${encodeURIComponent(k)}`}
                    className="inline-flex items-center h-8 px-3 rounded-full border border-background-300 bg-background-50 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {k}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        <div className="w-full px-4 md:px-8 py-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-8">
              <HeroCarousel items={hot} />
              <CategoryEntries />
              <LatestNews />
            </div>
            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-28 flex flex-col gap-6">
                <HotRanking items={hot} />
                <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <h3 className="text-base font-bold font-heading text-foreground-950">关注我们</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    想第一时间收到热点提醒？关注吃瓜网官方账号，或在关于页面留下你的联系方式。
                  </p>
                  <Link
                    to="/about"
                    className="mt-4 inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-accent-500 text-accent-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    前往关于我们
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </div>

        <SiteIntro />
      </main>

      <SiteFooter />
    </div>
  );
}